import React, { useEffect } from 'react';
import { HelpCircle } from 'lucide-react';

const FAQ = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <div className="container mx-auto px-4 py-12">
      <div className="max-w-4xl mx-auto">
        <div className="flex items-center space-x-3 mb-8">
          <HelpCircle className="h-8 w-8 text-purple-400" />
          <h1 className="text-3xl font-bold gradient-text">Frequently Asked Questions</h1>
        </div>

        <div className="card p-8 space-y-6">
          <section>
            <h2 className="text-xl font-semibold gradient-text mb-4">General Questions</h2>
            <div className="space-y-6">
              <div>
                <h3 className="text-lg text-white mb-2">What is TheMostUselessWebsite.com?</h3>
                <p className="text-gray-300">We're a unique platform dedicated to sharing fascinating but completely useless knowledge. Our mission is to make procrastination more entertaining and rewarding!</p>
              </div>

              <div>
                <h3 className="text-lg text-white mb-2">Is it really free?</h3>
                <p className="text-gray-300">Yes! All features are completely free to use. We're supported by minimal, non-intrusive advertisements.</p>
              </div>

              <div>
                <h3 className="text-lg text-white mb-2">Do I need an account?</h3>
                <p className="text-gray-300">While you can browse content without an account, creating one allows you to track achievements, maintain streaks, and participate in daily challenges.</p>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold gradient-text mb-4">Features & Functionality</h2>
            <div className="space-y-6">
              <div>
                <h3 className="text-lg text-white mb-2">How do achievements work?</h3>
                <p className="text-gray-300">Achievements are earned by completing specific actions on the site, such as maintaining streaks, liking content, and completing daily challenges. Each achievement awards points that contribute to your level.</p>
              </div>

              <div>
                <h3 className="text-lg text-white mb-2">What are daily challenges?</h3>
                <p className="text-gray-300">Each day, we present a new useless challenge for you to complete. These range from simple tasks to more complex activities, all designed to be entertaining and slightly pointless.</p>
              </div>

              <div>
                <h3 className="text-lg text-white mb-2">How do streaks work?</h3>
                <p className="text-gray-300">Streaks are maintained by visiting and interacting with the site daily. Your current streak is displayed on your dashboard, and maintaining longer streaks can earn special achievements.</p>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold gradient-text mb-4">Technical Questions</h2>
            <div className="space-y-6">
              <div>
                <h3 className="text-lg text-white mb-2">How is my progress saved?</h3>
                <p className="text-gray-300">Your progress is securely stored in our database. For non-account users, we use a client ID stored in your browser's local storage to track achievements and likes.</p>
              </div>

              <div>
                <h3 className="text-lg text-white mb-2">Can I use the site on mobile?</h3>
                <p className="text-gray-300">Yes! The site is fully responsive and works great on all devices.</p>
              </div>

              <div>
                <h3 className="text-lg text-white mb-2">What happens if I clear my browser data?</h3>
                <p className="text-gray-300">If you have an account, your progress is safe. However, for non-account users, clearing browser data will reset your client ID and progress.</p>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold gradient-text mb-4">Content & Updates</h2>
            <div className="space-y-6">
              <div>
                <h3 className="text-lg text-white mb-2">How often is new content added?</h3>
                <p className="text-gray-300">We regularly update our database of useless facts, records, and inventions. Daily challenges are refreshed every 24 hours.</p>
              </div>

              <div>
                <h3 className="text-lg text-white mb-2">Can I suggest new content?</h3>
                <p className="text-gray-300">We love hearing your suggestions! Feel free to reach out through our social media channels.</p>
              </div>

              <div>
                <h3 className="text-lg text-white mb-2">Are the facts verified?</h3>
                <p className="text-gray-300">While we strive for accuracy, our content is primarily for entertainment. Some facts might be exaggerated or humorous in nature.</p>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default FAQ;